import api from "../../api";

export default {
  async fetchWorkedHoursReport(_, data) {
    try {
      const response = await api.get("/new-kambuchi/reports/worked-hours",data);
      if (response.ok) {
        return response;
      }
    } catch (error) {
      console.error("Error fetching worked hours report:", error);
    }
  },
};
